import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_ADMISSION_LEVEL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface NonNationalApplicationStatusResponse {
  selectedAdmissionLevel: string;
  ceqAdmissionLevels: string[];
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: NonNationalApplicationStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAdmissionLevel = ({uuid, onSuccess, onError}: Input) => {
  const getAdmissionLevel = async () => {
    const res = await axiosClient.get<NonNationalApplicationStatusResponse>(
        GET_NON_NATIONAL_ADMISSION_LEVEL(uuid)
    );
    return res.data;
  };
  return useCustomQuery([GET_NON_NATIONAL_ADMISSION_LEVEL(uuid)], getAdmissionLevel, {
    onSuccess,
    onError,
  });
};
